import { CopySink } from './copysink';
import { IModel, IAttribute } from '../base/annotation';
import { Metamodel } from '../base/model';
import { shellStringResources as stringResources } from '../../Resources/ShellStringResources';

@Metamodel.model({
    abstract: true
})
export class TabularCopySink extends CopySink {
    public static readonly MODEL: IModel;
    public static readonly PRE_COPY_SCRIPT: IAttribute;
    public static readonly WRITE_BATCH_SIZE: IAttribute;
    public static readonly WRITE_BATCH_TIMEOUT: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'WRITE_BATCH_SIZE',
        display: stringResources.ModelName_WriteBatchSize
    })
    public writeBatchSize?: number; // we don't give default value, backend will auto detect

    @Metamodel.attribute({
        templatable: true,
        association: 'WRITE_BATCH_TIMEOUT',
        constraint: {
            pattern: new RegExp('^(\\d+\\.)?((0?\\d)|(1\\d)|(2[0-3]))(:[0-5]?\\d){2}$')
        },
        display: stringResources.ModelName_WriteBatchTimeout
    })
    public writeBatchTimeout?: string;

    @Metamodel.attribute({
        templatable: true,
        association: 'PRE_COPY_SCRIPT',
        display: stringResources.Dataset_PreScript_Label
    })
    public preCopyScript?: string;
}
